var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06238 19H19.2193C19.6508 19 20 18.5943 20 18.0928V9.74258C20 9.24115 19.6508 8.83541 19.2193 8.83541H6.9055C6.47396 8.83541 6.12477 9.24115 6.12477 9.74258V13.7541V17.7655C6.12477 18.3416 5.77723 19 5.06238 19ZM5.06238 19C4.34754 19 4 18.3416 4 17.7655V16.3703V16.7187V5.77895C4 5.34833 4.30142 5 4.67202 5H8.97097C9.94606 5 10.091 5.60478 10.2623 5.9244C10.4336 6.24402 10.8388 6.86411 11.3873 6.86411H17.8176C17.8176 6.86411 18.6411 6.84498 18.7136 7.52249V8.6823",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.22eb31a6b513585b0736014a83b88188.svg";
export { ForwardRef as ReactComponent };